<div
  class="cb-battle-finished"
  [class.nuclear]="battle().mode === 'nuclear'"
  [class.equity]="battle().mode === 'equity'"
  [class.crazy]="battle().mode === 'crazy'"
  [class.normal]="battle().mode === 'normal'"
  [class.is-one-vs-one]="battle().max_participants === 2"
>
  @if (battle().type === 'team' || battle().max_participants === 2) {
  <div class="cb-battle-finished--blur-top"></div>
  <div
    class="cb-battle-finished--particles-top flex items-center justify-center two"
  >
    <ngx-particles
      [id]="'finished-particles2'"
      [options]="particlesOptions"
    ></ngx-particles>
  </div>
  }
  <div class="cb-battle-finished--blur-bottom"></div>
  <div
    class="cb-battle-finished--particles-bottom flex items-center justify-center"
  >
    <ngx-particles
      [id]="'finished-particles1'"
      [options]="particlesOptions"
    ></ngx-particles>
  </div>

  <div class="cb-battle-finished--middle">
    <div class="cb-battle-finished--total">
      <div class="cb-battle-finished--total-prize typography-title">
        Total unboxed:
      </div>
      <div class="cb-battle-finished--total-value">
        <app-balance-icon
          [color]="
            battle().mode === 'nuclear'
              ? 'var(--case-battle-nuclear)'
              : battle().mode === 'equity'
              ? 'var(--case-battle-equity)'
              : battle().mode === 'crazy'
              ? 'var(--case-battle-crazy)'
              : battle().mode === 'normal'
              ? 'var(--case-battle-normal)'
              : 'var(--yellow)'
          "
          [balance]="balance()"
        ></app-balance-icon>
        <number-flow style="color: currentColor" #totalValue></number-flow>
      </div>
    </div>
    <button class="cb-battle-finished--button" (click)="rehostBattle.emit()">
      <app-game-icon color="black" [game]="'Case Battles'"></app-game-icon>
      Re-Create Battle
      <app-cost
        [gap]="4"
        [cost]="battle().value"
        [color]="'var(--black)'"
        fontWeight="700"
        [balanceType]="balance()"
      />
    </button>
  </div>
</div>
